import { FLEXBENEFITS_EXPERIMENT_KEY } from "core/constants/experiments";
import {
  useFeatureFlag,
  UseFeatureFlagResult,
} from "core/hooks/useFeatureFlag";

export type UseFlexBenefitsFeatureFlagResult = UseFeatureFlagResult;

/**
 * Returns FlexBenefits feature flag state: { enabled, isLoading }.
 * Thin wrapper over useFeatureFlag so components import a named, typed flag
 * instead of a raw string key. Mirrors useWalletFeatureFlag.
 */
export function useFlexBenefitsFeatureFlag(): UseFlexBenefitsFeatureFlagResult {
  return useFeatureFlag(FLEXBENEFITS_EXPERIMENT_KEY);
}
